module.exports = __webpack_public_path__ + "static/media/traveljournal2-icon.9702acab.png";